import { provide } from 'vue'
export function useSubpackageName() {
  provide('name', 'cabinet-front-id')
}
